module.exports = __webpack_public_path__ + "img/chiefwhip.50ddf051.jpg";